import React, {Component} from 'react';
import {Card, Col, DropdownItem, Row} from 'reactstrap';
import {Link} from 'react-router-dom';
import {activateAuthLayout} from '../../../store/actions';
import {connect} from 'react-redux';
import axios from "axios";
import LoadingPleaseWait from "../Subpages/LoadingPleaseWait";
import {Editor} from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';

import {MDBDataTable, MDBNotification} from "mdbreact";
import Select from "react-select";
import Switch from "react-switch";
import { withRouter } from '../../../components/elements/withRouter';
import { getApiRoot } from '../../../helpers/Utils';

class ViewEmails extends Component {

  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onContentStateChange = this.onContentStateChange.bind(this);
    this.handleSaveAsTemplate = this.handleSaveAsTemplate.bind(this);
    // const html = `<p></p>
    //   <img src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAMAAACZHrEMAAAAxlBMVEUVBHEeATogATEQCk4oB6gZAicXAiASB2kQBFoYBYyTDa8cBBclBxL3ABT6ABn5ABb4ABu8AAyAAmlmAyUoCAzOAA7zABLOAAvhABDeAA36ACDMABO6AAjfABfzAA70ABD1AR/mABSYB1cxDQapAArsAyCSAAifAQqmAgvvAAypGER+AQZVAgFrAgPnCCQQoNBDHhGyMUnXGC7YBBjQHDg/BgCkFx1nIAYfIAB4Gg6cGRU/HwE1LQMkCQAJFAAgFwAzMwwFCgAE6vS0AAAAQXRSTlMaHSIlEicqHSEWDC0xx7S9rOQVIzbg0PPa6KLK+bvl2ZfLGz30iPnj1PIp+v79eBFKPGSnTf2B2+O6ouvQ/vn0j+K7nzcAACAASURBVHiclZwHe9pMsIWFhApFjSIkqmRTDBgIxd1Jvvz/P3XPzOwKYSf3PnexHcBYejlzZnZWSDEc22u4roFRb+CmRw3DqBmmadoGPTbMmsHDbBhqmKbhOg39J4364dDAy/G6urykgVHD43qDR52+DGzVaNRq9cqu6nhK7hi2rTdPry1fYjBMDRsz6ZVNDdMwDbzcbTCMyzCHOn01m+fpe6Pete42zQOGwJg1k98kbZceEwx+eMSiAGlfareGwzDuv2FulREYuadgwNJs9n60Tn5/8HZ/6g/i9+fn57sD0ZBSSpTGF5hGqU6Ndtukd+z8H8rYpEyzCoONHLqd3sYw3YZJIPX/Xj4ed9tt0F/252k4no/H40F8oG11QXwNUwlTYxh+iiQrlUGYlAfqVRiXYTwKU40tARjXcN3D4fL83/3zcjl/Nqzj8/OP04/j8zxL5/3xKopX4fKhWGbz3Taev9d/PJ+sGohvYfCmxDMNHb9aNUzCUlPKNCowNQXTZBi8p8OP5Xw63+128+WPo/tjvZ4vx8v1IJvGcbxazVfx8qE/n8aruL8E73h89L4pQzBulUXCRPtlZShOtVrjuzK1W2UOh9E8Hvfny+12uXx+H2B38WDQn8+38xg7fwTkbrkcDEb90WoJoDg+bLo1jsXflJGnNcxNmP4G42qYJsHUn8eDfj8bxfMtxq69GmxX43g8xsM5gB53j49PT4+78TgexbBxPCoemg2kGVuZty6pzcpoT3+DgTK1f4bJ1mFqNJ4hCGIwilfb3Xb3Nk+yQTxfPuJZBGgHEBh3MB8gdutsMJ2uzg/n8dv7+/P9oX6FEWXEvFLZNExTYFwUIjwjla+EqUmYPBWmRjym8CyXD/EKgZnu5kUyz+Lx/HELlvnu6Wc2HW/ng8F4vBtk/fEg3S4zPIJ1Rgf3BsZVdUYiWKtmUw0wtYaCUaa6wtgMUzdr9+P4Ybt7XEIUcs10+ZgW2yXCsd0tCebxzzrLwINcwpPT6XyJF88RxOX4/dAkw9wa+ArzJUwNLsmGrssyHQClkk3Gj3GczrereDtfzp+eluN5ti2Wu91gvH18hGd2H7/m83Qewz27x/FgvszwSwonnnmw3jpfYUSa+lcYKu5Qh6eU78qYShnArNL5alnE2+3T08/lYBnvZsvHp+UcAMv58uPzz3ye7PoD5NN8PoAgxLLDb8Z9aNNkGLaimgf/qQxe4ZIybl0yXilzTW2E6TheoZosV6P+8vHPzx0yfNlfkUwoNHH8+fr6J56DEAy7LcIY7x6RcvgXf9OnelxRxrj1TAnjkGf0LMtzAsNUlDEFpvFjsEJmr7ZFvIRPIMgKkaLqslwvx9njr18/56gyW4nNth/jF6RM3N/G2TOlt2GUMI1y0MzDMM0qTE3BCE2FxeNXIkzzeJAOlh9FPKKdwLZIYyot22ywmz/9/v00f+S6B5bHfrx6+v2B133Ey22SHTsMY2jPNCo0xs2sTdnk/l0ZdrByNMI0SOPly+RhtHqiCve4Gi+p1lG+P/76/fq0fXzCswB6QnC2r4/kmY/546jI2lx+/wHDqd0Uz9hkKdd1G9yoKGXcUpkytY9v84ymgnA1Sre000dkFmyK73n869fr7987gYFacNf2E7/ZPb4sd0nad7nofQlTXYdJKdMQGJcmZAXT+ALTVZ6pNd9fSpglCbNN+qguO5oM4sfX118fnwxD36t5/+WJIvb7ZbcqkgexzP8BI0XP4L7zqkz9xjNmnSYY63h8/i9Dxu6KuOgjOnj7BdKcXELZ/fK5P308McwHSvK8/4lQ7h5fX+DgDK0WmlLavmpnqwauVZWhXtbl3Bdl6o3GTWp3683D8TQZ+c+QZrncvb/N+zHFCTCgQuYQzMPn2+L9Jznm8RO1J56/Amz39Poyj9PsjPF8OeK9e6SMa1Q9o2Gaf4X5kk3u4bjHGBXv/31iYnx6++yTbz9et5PRCDSIEywyfn9+23+wYV4/0FK8/PkJmp+vL4M4S/cLwkkn++PB/aKMgmmyMo6CUU3912zyjMZpAZT8/eXlv//++4QfP17709XH08d/T0UxGSFzt48vq3jw+fL2/sxhQmiW27c/P0Hz8wMwgwVg8vMkyN/P58vmcBumxk2YbIJxAaN6T75pls1+cn4eFcO3j89Pgvn4/fHzc7fuv/7GvdUk7MdU5z5XVIJ///n8fH16+gXT/oROJM2vj5fxcrJfACYv3l5/feZpuKiXMIaG4dw2oIxtKWUEppraZneRL3L6yl9eXt6en9/f0J+8vU/Ob29vD+e3EZSJV8uXz5f5xx8en2+Iz9v+tH9eEM6fXy+rM1hA8/b6+vvXOSiK06FWtlZXZSitRBnQ1KQoKZaGKON5eyYZDnP6GUXRcBgFeDQcnieTSYDv0WhE36OHh9XLy8frb0xRH28LsLw/7yHVeZGfFQpY3oJkMMsuNwbmxYJkNiljut9gtGesM7PQjTiiyRlAk2iYRwRDGKj70YOMePRAWKPJw/v7ApIOJ5NhdCaW59dfGC9nsGT99f4WBoaWctIQGFcV4K/KWIcFwRBOrmAm0XkIGigzIlni+GE+fNBj9TAiKGKaBMXDakTIxcQPwwDZFEVBNkD/deg2jBthyjA5NDkJTNnP4KY84x0RpiHFCSjDCJs+491OEK6cgzN6wAIlGpU0aNaLftrvj/qToh+PRoGMMCwIKEjGWba+1DEZagMbvFyUHgqecaQEX5VpqGwy4ZmuSzBqRBwb8FCgzg8UD1JjNTk/VLTp08DyoI+VSj9NkyLESFI/hDADCIN++H+Dsd1ynizD5ErJ6xonlkWkiUiayQgsQZSPyCHEsppMSmFWKP6QBU7CAE4/LUJo4tO/QVSMs+n6iG3rMBlS80oYCpP2jOt+qTOeWeuShUtp2LSTaAKYyYgNApiRhhk9LLcj0oVZsIgb9QsWJu1DmSAaZIP15FAjmJJGw4hnWlCmhGlomHLWNvZ5BSbiZJ4EAQw0GkmUIM1VmOWI9IhlQCJ4BY7pAyYIJgjS+ujWlDJGqYxZb1wNLGGSVaVa53llO3M8X00TnAUGJSYajpQwqzK3aVFbwiDRwMLKpAOG6Q+y9flgflXmjo8nUWZ/g5GqqGD48MxZlMkpn4JIyhy0GRYjxbKM2LkrsQxjKGEkSn6/P0h8ilK23rgmhcUQWRp8GMuUOvMXGLWcKZXpepezhoE0XHQfQBNGocAsAUMZTjBYbeogPZBpUhFmjDCFUTFYQ5hu7RtMrYRptXjarvGhCLdcApcdhGUa5zPXX67BAVc60IQTwMQkzBwwK1bmAYuXWDuGMxuW8X3KK8BkJAwVDLemD08ZAmPW5Wia0ZISXMKoCezaztjuiWCYhpVBmFDOJmFQMAvDcJwe4uVcSFYqTAXVumLMMLDvenHgKP0FhhtzgeGjW5xNShpVZ8gzptM4L0QWqr0QBJ4AUBEkfaLBcjaCVojTaL6Mr4OLjI8yg4YGMEG6nq5dr8swxnUApisGxoMWzwcK5rrsFF0IxnYal0kO60qdmciMVIVZwkXKMnFFGLKv74swWRpAmGcUX6rrWhkFY1ZgdJhImbpOJ+8KY7sHzJIRlZYoRNtQFBSnuF/4acwsDIMRL6vKqCj56XiAWaA/Wa+zg8EwHCa3PJzMBubFHAxM6VSTtYGrLdPQjunaXds4bIocMBiBH04KKiUYBQrrnJbaS8BVYVZcZfoUpQT2FZg0W58Miw6F3XiGJm2tTO07jOC4ep1C66r6YU/epW/MNH6RpkTTB0w8n1OY+iqtVtfqG4/AggFhiCbNsvTgdm9h9EqqVhpYw/CyUgtTKgNpbKN+OKDkSjPgYxcFw8RJmg7GDBPHc+gxp1nyauC0SDD6dGgNMOv10XDNbzBGTR/Rx7wAmBbBcAgrMN5VGctoXBbBFCSsDEtTYG/jYjrLxmOsMSeEQBpdYTBdpsSSDuYizHoWHTSM25AIsTIwphwQNa4wWpm6hjGlytjeceEn4XDmS5cEmqLA6hm7TWfTDC3UfFsQA0lUTpLEAph0lrIw/WQ9LaZNWoR8hXFN06s1yjDRtF0z9OJfh8lUJc88JmjT4BdIE5I4CYUpzVA7+rNpFA5S9AajAVZ3EIkY+1xXWJg0nQ3mFKQEqbT2DxUYQ8PI4ShZJZQwDQVTLxtTCZNHUiRJMMSeozDxh0NKK3SdGGE49LFj/HI4Asp4jhZ30B9DmCyFMLOZEiadrafZet/w3NoXGJfetQpT7Z/KuBImu7afRWCZJUGORILu4ZDCRXUHEUvC2YCKG61eRrBMBkBEEdmWpUDJZuKYBFNkNj0akqJfYGrdWxjTcyW1jUqYxL6NELWF3iPRYO+zFDQI15BpyKA0JfsRrawexnmElyA6KX4msyzNWJhZCnH86d5wPddlmDKXsHg09edjgGn/HcYTGLN2oXZ6RjTDyCcYpgm1NNmAolKwVJgz8EwqI0FfhaK4Qn8FsiCYTRd11/VqX2Dwrrt0CFNgSmUMDcN9hlLGtL0Tkplgpn5OyqB4UVYpGBh5DBo0CJEUaGJBtRWgAooFAZW+MEum0cHz5PDpFcbgHbklTLvlmJ46VGSUK3JTw9iNBaTJZtNpBrti71OiCXWcGGbcD8lH0RCmQkKh9qvhRwXFDQmIlx4NLJcZRgKkpib+sO6vMI0vMLbddawoDGfT2TRd54gTWqSsgDWwa6qABANpfIaJShi6YUQo10nKNAl6GdfzOPzuX2Gw5G8DBkX2a5hKGKweNtjplKSZDeFOSAOP+DJThQomFRifZi1awXLBgV5pSLVvRpGixHbFitzmKs/w48bVwAyjJ64vMCYWedYRSc3SnPE+satBhvUHS4PGHwWGTMM0PiDiLIM2rE/UD0mXFCjJBbMkSSOeqcB0KzAtDSNhMr6GyXaczeGEgjLFyCJsegqaNPAjloayFzR9XynT56lAcAKs3FCEM4rS5OBaioU8c6uMcaOMfBjnKhijhGEW22ocFhKo9URJ00fXz4EqCCYeo7khmgTC0FTEIw0zEiZLyTEXpI22jMDI1GyIMupDOvaMWXpGDvHfwpiNxiHyycMZpJllQsNSBCHN2/N4nDIcpk30UhlJA5YB+TnLwOLn1HB6CsYsYfCDDjR/gzEasniqKmObGsat+z4FCtIAZprh3bNLECcOEzotgkGUxtTW0SioDgOGheEp8huMyzB/UaYapy/K2Hh82CQ+Ct90EHCcsgESiMIU+AMxTcHKxFT/xb0+CZOxMMn+0DW8K4xbwhisjKHm5gpMg17QqChjX2HcxuE0S8jDaTjLyMKD2B+yhwWGTBMN+wQjwlD9TZHlXPEaFmW1gqlVYFw59eM7jFam9IxtM4xDygBnkRDNmi28xpQk0kToK6nS9Csw5BgfaU0FJ0FneKLdXpXxKjAuGfgLjFupetIMahoHNzxVNywvEBP7JD7R+DwdFaTMWGBGYxUmWmUnSpiQJqUrjEUP1KihLSZljBvPqERTYVIwls0F2GaYRte6JESzVtk9RrEh04RjloYMHQFmwCUmxVISjQOEQZSOVGJcz2YYC0yiDKsjylxh2q3y3AwVJu5MZTJwqAyxjTzbzTmjpr5YeDwIaTHFphGYoK+EgWHCpK9YFhDGK2FMs6KMK/ODXrNUYBqlZxQMCwPLOGTghufYR58zKlHSjGVGSq8wIw2TFGEfwlCQkgMVO3zb38PkfYf5ZuCqMmJggsFCYY+GBtKEM3HNwCdpfIbB7BRqZeiwTKKDdOIp6f+AaSiYHmA8V4dJ1pylMvYNjGmhmQDNzC+lAQ3HCTAY7Bk64Eq9hbCEh67HwxIYG6bh5OLD8qg+WCbqPsvokYMVTEUZu4SxrzC2dZlxoEKaFMAgrik0jM8w7BhxL09KDONqGAsw2rwCY+rTVJRnrjBqOaNhOExOCWO7i5nP0sxEmoJrDSV0Ssu7VGDQ9qogJQvLNW+UsarKeK6pskmUQZgYRuf2FcbSRY9hDIJxrC66SJYmJdOMM56gyCp9aqD4DgkzEGFCv90yPFHG1DCWx0+JZ8xSGRRjVsb5G4xdeuYKY7esy5RMPKPySienUA5R3cMKlhZMSpiyxOxbbYHxrjDmFxj7CtPrQRoF868w0Qk2eIqHl09JGiS5kiYKaX4CDEruSIThIKVJ6Ad2u+V6OkyWGNgzDSo7f1OmCqOUcVWYHLYvwfBTji3aJESTkjRrKXwsDQRBAywwWpjkgnbftbQyuGPRkQRTK8NrOtu0/wXjCoyHl1haGVtgZKZqOUdYRkszGCd8aIIcnDIMNeADNSnlVrsKIz+R22WYGMa+hWHPEI2uN2QQHaWW0zL4lBYJU6ttntZJCNfMSBruzf2wr/q7cUa9XeleqqiuaVWyid4h958CY7AdVC7fwrgljNozw7QqMFCm1bJOa6wWCuR4Rqt6WuUm1DpgWTDGElOXGP9ktSlMX2HMEsYjGPs7jKuVkYCJMiIMeaamPUNsbfu0niSYFKYiDUpgwgfueP6kwS1V4JIyrZs6YzGMChN9V2BqpWc0jCtrGk+1MsSilXH4GYLp2RfYJvExTQ3Ga5+mz5kcuSMQXXuPVothvFIZS6Jk6tIjMPQREylQhTG+w7BhnGuYHFEGNNYRKFSL1+PBjA+ZsCSZfEGYLLtYtoKpKmN+hzG/wRiVMOGuVXFMCQMWoMEH7Z7pboLZjKVBTGbcqtMYE1NWJOtiY9kCg9CU2UQsyCa3DBNLZaupqvb/gWGpBMbyNqfFDPVmvR5nfMAEIrFrBut1sl4vXKpSBNOuUXnBjeqMwHhKLOogLFHmCtNruddF1S0MB+WaTS0NY7r7yyIRGDrcizyOZuvBekoHzM7no0eLCqf9TRnebhXG/qqMgpFpVNpT09HK0PawulHKtOTd9iw3Oua8WpiuF/vTBWMzWQ/Akl0O9RodJ7RZmV5bFz1MB8CyHF1n2DMeG1jyRzyDP/gCY5QVj/eNx+5NmNqmG3aGIR/tm55OiwUdzENFBto6PRmoL1y6CZsqsPUdxlI832FanobRg2fsFucxhiEwkl0cJvsUNfNFRA3VjI4lztKMe3XQ5Hl0dK4wbd4vJzVgLDGwEkuHSXZ/A1OJEmeO3dLKMIwhE5WEycv3nX2zc8kxS9LBR/rUGrm1hjL55RIuRBoNw/suYUxTi8XPQvDaX2HcKoxkEieEgqHFQls8E1zqi/2m2dyc8kQ+pEtma2IJ8uFpk19azN27KmOiM6vAVJVRMOhz7hlGN+z6X6m+2q6YQmgaYQPzE+3TdBJE+2h46jT3MzoICgygYPoMhvlwsaGjPq0WWEplLAWDNPO0WJ5rVcLkUTbdw2SewvBKZSSvWYd2zaXX29dnnJD64GCR+8ElIj1AEq3XsyTwg1mU5/m+R+bi5Cg9Axi7hBEaBWNqmHvOpq/KOCVMj5RxWRmuMiR9a09NOXaNNAoCn1mCxSZDvaN+fZifekTDMD1dZ5wWBYnaIzBULVNR5v7+HvQyUfBTnsBwtWvz5ggGhcZmWdhjZ8obGDfI93sWZurvD3sf96jPmebt3v6Ezd7T8Cg6UMJpS5QcWm0rQulUpGnwBOa+x6KJMIIlNsWQ7WHGBiA9lCdOnDeYDmZhTgToXZp7NBUIGcIXuu172Kndvv/x44fAUIHpgcS6gbG8LzA/5A9KGJm/enrwvqEMYGz1DJ7bX7Ai2ufo8SDPeub7l+Y+nCX5PqTDkPuNdz8cXqCMeEaUoWO4FnexJlmInrK0MjJtekoZ1QbKfIF/ORvaHBfcobRThZCz6RRd9jmSOQl56T0NLoc9yk20z6FWkU1nk8X+aLO27dLA5F5LPCOHaugXyjNU3wimx5OZ51Zg8NXSEzZVL4YxXFNNN20rJJhoGPisDGan5h5lBnaeMQymrQtz0HeZ2jwcDWPxTS9/PJk7DfqDlu6Py6SiIyHCQj9QHWusDBfgXmvBMBF9uMSHSKbR0J/5+R6WmU2KLD8trJ7AVFLbstUSlVZOWhmHj4x9g1GLKrlZWhluAlo1l65lMrkf5zJzEhjMTQkdrklofhqKMEGa7vcnmJ1qADlMPCPFV1KbYcQzji2F5+8wEimrpaovv7ceFn42tRVUZ8TDlwV/OkjK0FlmwWwd7fdc9qI0ueRHSiTJvJ6lBoqeWqCaOsEs7wsMp4tVZhP72nXuy8Sh7dXQK2EaudcDCdg9LVD3BSWkz9nWk0UgMOElb7XBct/7cU1twLT1mtDUfIDh+d10NcwP3Oh5tyx6BEMM9wrm3vTIxAKDl9NOLIhnTaZ0ZuUC3RV/ikmfSvkBLLO3WgzDdca0uJOROkPznfO/wfCmSxqOWAtb6sk3w7iA0cr8YGXa3fv2IkxOm03z0Gw2C1TjhIK2j2b7/eUiYaJN/7jCqMnXYQNVYSwN80OU8SwdJgVDb6yndm66LcwYlo4S7aRt2Sc/osNkAYkDDw+prYGfZ1Bqb8sG8MJeud+eoxaFXimMR2v3lmNVPNPract4cmDSVU0e1zzMd1Sc0Mhz86DKcMs7+sMwCRc5nRUWzDhOBforf7ae7i1pe9pSZ5RnqMljHrauFGEuIFcYSqaW5elyp7KJWqDyWBElm+VyivHcia97x6LjnEmygA749qe0oPWjgM6/8Oq2eif04ms22SqdVMVjGF6y6sULV+C2pVcOSp1y2STVhuZ6KsuS7Fw+vAV9+u7TGoUiFa0T3InyfZD66ONs1ff0/gFjSZkhGNqF6UmLfoVR7YOEySkHycGtPWDaZaCcZzSbIX1gvRgmmKozzA1+kC+QWtER6I6ShbatTCMwZBGZJQWmxQZmZSwpem0VJp1MDKN6YA2D2LWVMvj+QSdj0ElMwTCcYUmZnbCKAwt3ebAXtZxSMnvaM/QphDj4mtkWN+1tS1gYhg1c2oaGbsWVFnirLfyBjhF+TEJ04eSSYeTTJ6JpP8Q8GVADnC8MFKG2bkCkApM4bSjDQngVGH6h7cpUxW1nz9JrKoGhYxllA0wLEzxDMDqXWuckiPKhTyf5YHYimGyyzxE0pHmRu7QTNU/2ymxyeDpoiTKemrFEelut6lQ2WXp68MoGzLr6hjsA15IFHJCeE6oulEwsDJ0TkmYheiyqOZNgAy9QL9RTa20VF8eSD0Yc3RWzMpzrrjIw/4HqSEsi27mmk0PzkkUw0lS0neNMPkf2kyAPCCZMEjrZCDCIUz47kjFVjHnhTyB0E/+qbLJuYVgZDkjZrQuMzPbyKRw5WfWsslxo9ehMbIIJfVlip3y2XCLrynwxOzE3XkhKtnQ2WY76+Kp1zSZLZZP2TJtLYLnerMI4fFxDh4lcTDDWOQlJGTQQOZ1SMxskclIYH8ejOOWGyS/tkTgtZnHIM7IKdJRnFIyjYESZVruqjKcW6VcYW+o3wVCjZz0nAZ21HwYhnbUCYQiGzg9ES8wOzn3DUxFlGGUYizelw/QvZaowKpuuB171ZGKzMjDMxaeD0DSinBtPwBALHX/1QzpdIy82ng4Ttq4tIznRclplXnM2KWX4mYpnrupYtyyOJ8pQo3eMNEu4H/LpWATj80nICTjpfNTzyS1h2no6uB49df4CI0/xpyqtMte8fylDxyopSPTJG6P4wwVZOIEyIQkT0qlV9AnuEGW4YasokcfEMBKmlji0AkM4CobqDFUd5WBLlRlHJZKanfhgHAXYko6Br7FY0HlO9AnCgIThk0p9PnEFVjIsp6wzuuapw+u0b7uEcbjZ9iRMpTKlKDKnOc512latGRWvBWo+0xTDYs8sfjoY+HRCf0FnIvtyQmFw9FpXGNWJW3opdp2brFsYqcBtW0miiJ0yqfnvCcamH6ckCPKckjpaRLmcdZoN+j5dXjAhGMSJzjaPThZ3Pm3lGeUXDePp6crTcUNPq5VBjlgliWfdwkgDwvl9pNwNKDqJlSyikGHSMUDoJHeShmCG+Fq4pTJtqTMsjKPCdKsMTOJK5PigdLv6e8tS01e7nLtRUB3M83ydEp9rejomC3Zx6GdxUIxwm/DZgYgTEj7PXZra76X1ceTocTlBtC11CIBYJJIeP2XztXl0OnD1+ic59fI66BKbzmER8HmvYZDsm4hSyOfjhoNJSCx0mQafvx7xRT93ht6E0ah3Omoz9G+n0aELHnC308E/1191Oh2j3uTRof8+o9nk6xmb9U69iZfyw6Yex5xaO7D4efOQ0CErgkGMwmIkV8ZhSvD5mF4+vFT+8Dp4i9fRUTfeaYdheHT4hfLiDr2uLn/cUX+O1x8vp9NlQnocmseEDs6wg8kwpMyEXMP9cJ4PF/vDX1jkPWP3nQbfZFTuGXUGUxrovdeJhiUiMmJVYxKGs82huY/2vEIBTH/EV+pN+KJBaoqpi8gXB9pSpxx12W2nc0c/a/JkrdO4o0d3xh1ddWrcGUqL+vXWoRttCN9N0Y82ckfPnMP0Aia03nzsFwWnzyh8DdZolFA+UR+8OBp3GOrPOny3dndX6+KGO/QvHtXoXveuW8MjuhnNuvIJIfA7qHfqnZsh26QN1hf+/nBXO4ZyoRxdutKf8AWBJA2ixUV4iEXCCXupDLP7z6F+RTwGu5X0aDbrikUA6l+B8B6b+/xwd4coLfgaIzrlaiJXjLAwAhNCt8Xi7tte7b9CMAd9QR9DbCvKNEtVWIi7L7rc3R1O/DR2BmfwuWgVGgWD2A0Bc+xuuvTFEI6g2Pxl3uLIT4ocYJqiDTN9lUPCLnf4QZMEOiIOcoURXyQXXJUZUW7nYQiYk6AQkbPZXFWxqyrZIgxdyEObN8rUlVhpbbT3lCrV0dnTbEmXPAV07RWxhHKFJye3j4ki2i/23Y0eQuWIUptNt5RJofBWax3KJlXadDJpTcQlTGLcwmz2e76Mhq9CCK9REtOg0YGXIM0VRXA2XZs4nKtrKJN4NMQQHeNbqaRa8z2RBIO/MCL5VIeVkSue1OCyNwTnJb9sNkeKkKZhRTb2RtOUHuDBgYsQqgAAAKdJREFU9VApcy0zVCav5eVqZoUj47QQywzpyuDSvjQjUNkDTHS5nMByLKNENI6mKAk6zU4pAe4alUr9t/J9dTKpshEe7ON4QQ2mS7jFxqIQTU6Y2ZFopyMNCZOOU5eVqAB8G8a/fvEFsERiluMFt+Pp9Pz+wpdDn3P6fwDoqFFOxxsXnc2mImX3rvPP/f8/YP4xsHGSSfLlDk9Up0Xsd0Oh/bcA/xz/A5tpkEU6L/4VAAAAAElFTkSuQmCC" alt = "undefined" style = "float:none;height: auto;width: auto" />
    //     <p></p>`;
    // const contentBlock = htmlToDraft(html);
    // let editorState = EditorState.createEmpty();
    // if (contentBlock) {
    //   let contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    //   editorState = EditorState.createWithContent(contentState);
    // }

    this.state = {
      notification: {
        message: '',
        title: '',
        text: '',
        show: false,
        class: 'text-danger'
      },
      isLoading: true,
      includeoptedout: false,
      includeblocked: false,
      includedeleted: false,
      templates: [],
      editorState: EditorState.createEmpty(),
      clubs: [],
      users: [],
      data: {
        columns: [
          {
            label: 'Id',
            field: 'id',
            sort: 'asc',
            width: 20
          }, {
            label: 'Club Name',
            field: 'clubname',
            sort: 'asc',
            width: 50
          }, {
            label: 'Name',
            field: 'username',
            sort: 'asc',
            width: 50
          }, {
            label: 'EMail',
            field: 'email',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Status',
            field: 'userstatus',
            sort: 'asc',
            width: 80
          },
          {
            label: 'Receive Updates',
            field: 'optout',
            sort: 'asc',
            width: 80
          },
          {
            label: 'Role',
            field: 'role',
            sort: 'asc',
            width: 80
          },
          {
            label: 'Last Login',
            field: 'lastactivity',
            sort: 'asc',
            width: 80
          }, {
            label: 'Deleted',
            field: 'deleted',
            sort: 'asc',
            width: 80
          },

        ],
        rows: []
      }
    }
  }

  componentDidMount() {
    var _this = this;
    this.props.activateAuthLayout();
    console.log(this.props.location.state);

    var clubids = this.props.location.state.map(c => c.id);
    this._asyncRequest = this.load_data(clubids.join(",")).then(
      response => {
        _this._asyncRequest = null;
        // this.state.users = response.users;
        console.log(response);

        this.state.data.rows = response.userdata.map(u => {
          let club = _this.props.location.state.find(x => x.id === u.clubid);
          u.clubname = club.clubname;
          return u;
        });

        _this.setState({
          data: _this.state.data,
          templates: response.templates,
          isLoading: false
        });
      }
    );
  }

  onContentStateChange(contentState) {
    console.log("onContentStateChange " );
    console.log(contentState);
  }

  onEditorStateChange(editorState) {
    console.log("onEditorStateChange to " + draftToHtml(convertToRaw(editorState.getCurrentContent() ))) ;
    this.setState({
      editorState: editorState,
    });
  };


  handleSaveAsTemplate = () => {
    console.log("Save Template");
    this.hidenotify();

    // check that the subject field is not empty
    if(this.subjectInput.value == '') {
      this.shownotify("Cannot Save", "Error","Please provide a value in the subject field for this template to give it a name");
      console.log("Please provide a subject");
      return;
    }
    console.log("Subject good");


  }


  //Select
  handleSelect = (selectedoption) => {
    console.log(selectedoption.value);

    var template = this.state.templates.filter(t => {
      return t.id == selectedoption.value;
    });

    console.log(template[0]);
    console.log("Loading template contents " + template[0].contents);
    this.loadTemplateContent(template[0].contents);
  }

  loadTemplateContent(content) {
    const contentBlock = htmlToDraft(content);
    if (contentBlock) {
      var contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      var editorState = EditorState.createWithContent(contentState);
      this.setState( {
        editorState: editorState
      });
    }
  }

  goBack() {
    this.props.history.goBack();
  }

  hidenotify() {
    this.setState({
      notification: {
        message: '',
        title: '',
        text: '',
        show: false,
        class: ''
      }
    })
  }

  shownotify (title, text, message, type="text-danger") {
    console.log("Show notify with " + title);
    this.setState({
      notification: {
        message: message,
        title: title,
        text: text,
        show: true,
        class: type
      }
    });

  }

  async load_data(clubs) {
    var _this = this;

    return axios.get(getApiRoot() + "/api/club?clubidlist=" + clubs).then(response => {
      if (response.status !== 200)
        throw response.data;

      let userdata = response.data;
      return axios.get("/api/templates").then(response => {
        if (response.status !== 200)
          throw response.data;

        let templates = response.data;

        return {
          userdata: userdata,
          templates: templates
        };
      }).catch(err => {
        throw err[1];
      });

    }).catch(err => {
      throw err[1];
    });


  }

  render() {
    var _this = this;
    if (this.state.isLoading) {
      return (
        <LoadingPleaseWait sectionlabel="View Emails" pagelabel="Send"/>
      );

    }

    const {templates} = this.state;
    var selecttemplates = templates.map(t => {
      return {
        label: t.title,
        value: t.id
      }
    });
    var filteredrows = [];

    this.state.data.rows.forEach(function (item, index) {
      if (!_this.state.includeblocked && item.userstatus == 'Blocked') {
        return;
      }

      if (!_this.state.includeoptedout && item.optout == 'No') {
        return;
      }

      if (!_this.state.includedeleted && item.deleted == 'Yes') {
        return;
      }

      // item.check = <MDBInput label="" type="checkbox" id={item.id} />;
      // item.check = <div className="custom-control custom-checkbox"><input type="checkbox" className="custom-control-input" id={item.id}/></div>;
      filteredrows.push(item);
    });

    var notif = "";
    if(this.state.notification.show) {
      notif = <MDBNotification
        show={this.state.notification.show}
        icon="bell"
        iconClassName={this.state.notification.class}
        message={this.state.notification.message}
        text={this.state.notification.text}
        title={this.state.notification.title}
        style={{
          position: "fixed",
          top: "10px",
          right: "10px",
          zIndex: 9999
        }}
      />;

    }

    const Offsymbol = props => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 15,
            color: "#fff",
            paddingRight: 2
          }}> No
        </div>
      );
    };

    const OnSymbol = props => {
      return (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 15,
          color: "#fff",
          paddingRight: 2
        }}> Yes
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="content">
          <div className="container-fluid">
            <div className="page-title-box">
              <Row className="align-items-center">
                <Col sm="6">
                  <h4 className="page-title">Note/ Email Compose</h4>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="#"><i className="mdi mdi-home-outline"></i></Link></li>
                    <li className="breadcrumb-item"><Link to="#">Note/ Email</Link></li>
                    <li className="breadcrumb-item active">Compose</li>
                  </ol>
                </Col>
                <Col sm="6">
                  <div className="float-right d-none d-md-block">
                    {/*<Settingmenu />*/}
                  </div>
                </Col>
              </Row>
            </div>

            <Row>
              <Col>


                <div className="mb-3">

                  <Card>
                    <div className="card-body">
                      <form>
                        <div className="form-group">
                          <Row>
                            <Col>
                              <Select
                                placeholder="Select from template if you wish"
                                options={selecttemplates}
                                onChange={this.handleSelect}
                              />
                            </Col>
                            <Col>
                              <label className="control-label mr-3">Include Blocked</label>
                              <Switch
                                uncheckedIcon={<Offsymbol/>}
                                checkedIcon={<OnSymbol/>}
                                onColor="#64b0f2"
                                onChange={() => this.setState({includeblocked: !this.state.includeblocked})}
                                checked={this.state.includeblocked}/>&nbsp;
                              <label className="control-label mr-3 ml-3">Include Opted Out</label>
                              <Switch
                                uncheckedIcon={<Offsymbol/>}
                                checkedIcon={<OnSymbol/>}
                                onColor="#64b0f2"
                                onChange={() => this.setState({includeoptedout: !this.state.includeoptedout})}
                                checked={this.state.includeoptedout}/>&nbsp;
                              <label className="control-label mr-3 ml-3">Include Deleted</label>
                              <Switch
                                uncheckedIcon={<Offsymbol/>}
                                checkedIcon={<OnSymbol/>}
                                onColor="#64b0f2"
                                onChange={() => this.setState({includedeleted: !this.state.includedeleted})}
                                checked={this.state.includedeleted}/>&nbsp;
                            </Col>
                          </Row>
                        </div>

                        <div className="form-group">
                          <input type="text" className="form-control" placeholder="Subject" ref={(input) => this.subjectInput = input} />
                        </div>
                        <div className="form-group">
                          <div className="summernote">

                            <Editor
                              wrapperClassName="wrapper-class"
                              editorClassName="editor-class-name"
                              editorStyle={{ height: "800px" }}
                              editorState={this.state.editorState}
                              onEditorStateChange={this.onEditorStateChange}
                              onContentStateChange={this.onContentStateChange}
                              >
                            </Editor>
                          </div>
                        </div>

                        <div className="btn-toolbar form-group mb-0">
                          <div className="">
                            <button  onClick={this.handleSaveAsTemplate}  type="button" className="btn btn-info waves-effect waves-light mr-1"><span>Save As New Template</span>
                              <i
                                className="far fa-save ml-1"></i></button>
                            <button type="button" className="btn btn-success waves-effect waves-light mr-1"><span>Save As Note</span>
                              <i
                                className="far fa-save ml-1"></i></button>
                            <button className="btn btn-primary waves-effect waves-light"><span>Send EMail</span> <i
                              className="fab fa-telegram-plane ml-1"></i></button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </Card>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card>
                  <div className="card-body">
                    <MDBDataTable
                      responsive
                      hover
                      checkbox
                      striped
                      bordered
                      small
                      // data = {this.state.data}
                      data={{
                        columns: this.state.data.columns,
                        rows: filteredrows
                      }}
                    />
                  </div>
                </Card>
              </Col>
            </Row>

          </div>


          {/*<MDBNotification*/}
          {/*  fade*/}
          {/*  show={true}*/}
          {/*  icon="bell"*/}
          {/*  iconClassName={this.state.notification.class}*/}
          {/*  message={this.state.notification.message}*/}
          {/*  text={this.state.notification.text}*/}
          {/*  title={this.state.notification.title}*/}
          {/*  style={{*/}
          {/*    position: "fixed",*/}
          {/*    top: "10px",*/}
          {/*    right: "10px",*/}
          {/*    zIndex: 9999*/}
          {/*  }}*/}
          {/*/>*/}
          {notif}
        </div>
        {/*<MDBNotification*/}
        {/*  autohide={5000} // by default = ∞ ms*/}
        {/*  show={this.state.notification.show}*/}
        {/*  icon="bell"*/}
        {/*  iconClassName={this.state.notification.class}*/}
        {/*  message={this.state.notification.message}*/}
        {/*  text={this.state.notification.text}*/}
        {/*  title={this.state.notification.title}*/}
        {/*  style={{*/}
        {/*    position: "fixed",*/}
        {/*    top: "10px",*/}
        {/*    right: "10px",*/}
        {/*    zIndex: 9999*/}
        {/*  }}*/}
        {/*/>*/}


      </React.Fragment>
    );
  }
}


export default withRouter(connect(null, {activateAuthLayout})(ViewEmails));


